import { cn } from "@/lib/utils"
import { MetricLabel } from "../MetricLabel/MetricLabel"

export type MetricTone = "success" | "danger" | "neutral"

export interface MetricEntry {
  label: string
  value: string
  tone?: MetricTone
  definition?: string
}

export interface MetricsGridProps {
  metrics: MetricEntry[]
  className?: string
}

const TONE_CLASS: Record<MetricTone, string> = {
  success: "text-success",
  danger: "text-danger",
  neutral: "text-foreground",
}

export function MetricsGrid({ metrics, className }: MetricsGridProps) {
  return (
    <div
      className={cn(
        "grid grid-cols-1 md:grid-cols-2 gap-x-12 px-4 py-4",
        className,
      )}
    >
      {metrics.map((m) => (
        <div
          key={m.label}
          className={cn(
            "flex items-center justify-between py-2 border-b border-border",
            "[&:last-child]:border-b-0",
            "md:[&:nth-last-child(-n+2)]:border-b-0",
          )}
        >
          <MetricLabel
            label={m.label}
            definition={m.definition}
            className="text-caption text-muted-foreground"
          />
          <span className={cn("text-caption", TONE_CLASS[m.tone ?? "neutral"])}>
            {m.value}
          </span>
        </div>
      ))}
    </div>
  )
}
